import React from 'react'
import Img from "../Assets/img/together-1.webp";
import Img2 from "../Assets/img/couple.webp";
import { Container } from 'react-bootstrap'
import Heading from "../ui/Heading";
import {Link} from "react-router-dom"
import { useTranslation } from 'react-i18next'
import LocalizedLink from '../../../../Components/LocalizedLink';
export default function Together() {
      const { t } = useTranslation();
    return (
        <section className='togetherSection'>
            <Container fluid className="together_section">
                <div className="right_section">
                    <img src={Img2} loading="lazy" alt={"main Image"} className="img-fluid d-none d-lg-block" />
                    <img src={Img}  loading="lazy" alt={"main Image"} className="img-fluid d-block d-lg-none" />
                </div>

                <div className="left_section">
                    <div>
                        <Heading>
                            <h2>{t('together.heading')} </h2>
                            <p>
                              {t('together.subheading')}
                            </p>
                        </Heading>
                        <LocalizedLink to="/fine-jewelry">
                            <button className="golden-btn">{t('together.button')}</button>
                        </LocalizedLink>
                    </div>
                </div>
            </Container>
        </section>
    )
}
